import { IAccessLog } from '../../../interfaces';

class AccessLogMapper {
    toPersistence(domainAccessLog: IAccessLog): any {
        return {
            id: domainAccessLog.id,

            panel_user_id: domainAccessLog.panel_user_id,
            panel_user_name: domainAccessLog.panel_user_name,
            role_id: domainAccessLog.role_id,
            role_name: domainAccessLog.role_name,
            county_id: domainAccessLog.county_id,

            method: domainAccessLog.method,
            url: domainAccessLog.url,
            module: domainAccessLog.module,

            status_code: domainAccessLog.status_code,
            duration_ms: domainAccessLog.duration_ms,

            ip: domainAccessLog.ip,
            user_agent: domainAccessLog.user_agent,
            browser: domainAccessLog.browser,
            os: domainAccessLog.os,
            device: domainAccessLog.device,
            origin_header: domainAccessLog.origin_header,

            success: domainAccessLog.success,
            error_message: domainAccessLog.error_message,

            created_at: domainAccessLog.created_at,
            updated_at: domainAccessLog.updated_at,
        };
    }

    toDomain(persistenceAccessLog: any): IAccessLog {
        return {
            id: persistenceAccessLog.id,

            panel_user_id: persistenceAccessLog.panel_user_id,
            panel_user_name: persistenceAccessLog.panel_user_name,
            role_id: persistenceAccessLog.role_id,
            role_name: persistenceAccessLog.role_name,
            county_id: persistenceAccessLog.county_id,

            method: persistenceAccessLog.method,
            url: persistenceAccessLog.url,
            module: persistenceAccessLog.module,

            status_code: persistenceAccessLog.status_code,
            duration_ms: persistenceAccessLog.duration_ms,

            ip: persistenceAccessLog.ip,
            user_agent: persistenceAccessLog.user_agent,
            browser: persistenceAccessLog.browser,
            os: persistenceAccessLog.os,
            device: persistenceAccessLog.device,
            origin_header: persistenceAccessLog.origin_header,

            success: persistenceAccessLog.success,
            error_message: persistenceAccessLog.error_message,

            created_at: persistenceAccessLog.created_at,
            updated_at: persistenceAccessLog.updated_at,
        };
    }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new AccessLogMapper();